import { render, staticRenderFns } from "./Penyaluran.vue?vue&type=template&id=94090606&scoped=true"
import script from "./Penyaluran.vue?vue&type=script&lang=js"
export * from "./Penyaluran.vue?vue&type=script&lang=js"
import style0 from "./Penyaluran.vue?vue&type=style&index=0&id=94090606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94090606",
  null
  
)

export default component.exports